import { Skeleton } from '@progress/kendo-react-indicators';

function OrderSummarySkeleton() {
    return (
        <div className='row'>
            <div className='col-12'>
                <Skeleton
                    shape={"text"}
                    style={{
                        width: "100%",
                        height: 50,
                        borderRadius: 10
                    }}
                />
            </div>
            <div className='col-8'>
                <Skeleton
                    shape={"text"}
                    style={{
                        width: "100%",
                        height: 50,
                        borderRadius: 10
                    }}
                />
            </div>
            <div className='col-4'>
                <Skeleton
                    shape={"text"}
                    style={{
                        width: "100%",
                        height: 50,
                        borderRadius: 10
                    }}
                />
            </div>
            <div className='col-12'>
                <Skeleton
                    shape={"text"}
                    style={{
                        width: "100%",
                        height: 50,
                        borderRadius: 10
                    }}
                />
            </div>
        </div>
    )
}

export default OrderSummarySkeleton;